export const environment = {
    production: true,
    logErrorInConsole: false,
    environmentName: "production",
    grafanaMetricsUrl: "https://doerr.grafana.net/d/dfSKW-1I2/dorr-production-camera-statistics?orgId=1&from=now-1h&to=now&timezone=browser&var-imei=",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    oauthBaseAPI: "https://api.camera.doerr-outdoor.de/api/v1/auth/",
    usersAPI: "https://api.camera.doerr-outdoor.de/api/v1/users/",
    rolesAPI: "https://api.camera.doerr-outdoor.de/api/v1/roles/",
    organizationsAPI: "https://api.camera.doerr-outdoor.de/api/v1/organizations/",
    profileAPI: "https://api.camera.doerr-outdoor.de/api/v1/profile/",
    resetPasswordAPI: "https://api.camera.doerr-outdoor.de/api/v1/resetpassword/",
    languagesAPI: "https://api.camera.doerr-outdoor.de/api/v1/languages/",
    smtpMailAccountsAPI: "https://api.camera.doerr-outdoor.de/api/v1/mailaccounts/",
    mailtemplatesAPI: "https://api.camera.doerr-outdoor.de/api/v1/mailtemplates/",
    registrationConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/registrationconfig/",
    firebaseConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/firebaseconfig/",
    firebaseDevicesAPI: "https://api.camera.doerr-outdoor.de/api/v1/firebasedevices/",
    firebaseNotificationsAPI: "https://api.camera.doerr-outdoor.de/api/v1/firebasenotifications/",
    firebaseNotificationTemplatesAPI: "https://api.camera.doerr-outdoor.de/api/v1/firebasenotificationtemplates/",
    paypalConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/paypalconfig/",
    paypalBillingPlansAPI: "https://api.camera.doerr-outdoor.de/api/v1/paypalbillingplans/",
    paypalBillingAgreementsAPI: "https://api.camera.doerr-outdoor.de/api/v1/paypalbillingagreements/",
    klarnaConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/klarnaconfig/",
    klarnaAboPlansAPI: "https://api.camera.doerr-outdoor.de/api/v1/klarnaaboplans/",
    klarnaAboAgreementsAPI: "https://api.camera.doerr-outdoor.de/api/v1/klarnaaboagreements/",
    webSmsConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/websmsconfig/",
    webSmsNotificationsAPI: "https://api.camera.doerr-outdoor.de/api/v1/websmsnotifications/",
    systemLogMessagesAPI: "https://api.camera.doerr-outdoor.de/api/v1/systemlogs/",
    systemJobPerformancesAPI: "https://api.camera.doerr-outdoor.de/api/v1/systemjobs/",
    systemResourceSnapshotsAPI: "https://api.camera.doerr-outdoor.de/api/v1/systemresource/",
    systemErrorsAPI: "https://api.camera.doerr-outdoor.de/api/v1/systemerrors/",
    imeisAPI: "https://api.camera.doerr-outdoor.de/api/v1/imeis/",
    camerasAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/",
    cameras4GProAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_pro/",
    cameras4GProWaAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_pro_wa/",
    cameras4GProRCAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_pro_rc/",
    cameras4GProRCWaAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_pro_rc_wa/",
    cameras4GProMiniAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_pro_mini/",
    cameras4GMiniRockchipAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_mini_rockchip/",
    cameras4GMiniRockchipRCAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/cameras/cloud_4g_mini_rockchip_rc/",
    aboUsersAPI: "https://api.camera.doerr-outdoor.de/api/v1/abos/",
    firmwaresAPI: "https://api.camera.doerr-outdoor.de/api/v1/firmwares/",
    appleConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/appleconfig/",
    googleConfigAPI: "https://api.camera.doerr-outdoor.de/api/v1/googleconfig/",
    crashlogApplicationsAPI: "https://api.camera.doerr-outdoor.de/api/v1/crashlogapplications/",
    crashlogErrorsAPI: "https://api.camera.doerr-outdoor.de/api/v1/crashlogerrors/",
    crashlogMessagesAPI: "https://api.camera.doerr-outdoor.de/api/v1/crashlogmessages/",
    textPoolsAPI: "https://api.camera.doerr-outdoor.de/api/v1/textpools/",
    stolenCamerasAPI: "https://api.camera.doerr-outdoor.de/api/v1/stolencams/",
    mediaCopyPairsAPI: "https://api.camera.doerr-outdoor.de/api/v2/admin/mediafavoritecopy/"
};
